import {baseEntityRules, naicIdRules, pbmIdRules} from "./EntityValidators";

/**
 * Entity validation
 * @param {object[]} existingEntities - list of existing entities to check for duplication
 */
export const createEntityValidationRules = (existingEntities = []) => {
    return {
        ... baseEntityRules,
        pbmId: pbmIdRules(existingEntities),
        naicId: naicIdRules(existingEntities),
    };
};
